module.exports = __webpack_public_path__ + "img/pic_recruit_picture3.c94786a9.png";